import { useEffect } from 'react';

/**
 * Hook to add a window event listener and tear it down on unmount.
 * @param {string} eventType
 * @param {function} callback
 */
export default function useWindowEvent(eventType, callback) {
    useEffect(() => {
        window.addEventListener(eventType, callback, false);
        return () => window.removeEventListener(eventType, callback, false);
    }, [callback, eventType]);
}
